import { Backdrop, CircularProgress, ThemeProvider } from '@mui/material';
import { brightpathTheme } from '@youscience/theme';

import useRecommenderWorkspaceStore from '@store/RecommenderWorkspaceStore';

import TeacherEvaluation from './TeacherEvaluation';

import { StyledContent, StyledForm } from './CommonAppTeacherEvaluation.styles';

export const CommonAppTeacherEvaluation = () => {
  const { isLoadingApplicant } = useRecommenderWorkspaceStore();

  return (
    <ThemeProvider theme={brightpathTheme}>
      <StyledContent>
        <StyledForm>
          <Backdrop
            open={isLoadingApplicant}
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, position: 'absolute' }}
          >
            <CircularProgress />
          </Backdrop>

          <TeacherEvaluation />
        </StyledForm>
      </StyledContent>
    </ThemeProvider>
  );
};
